"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useGuidedSellingStatus = require("../../hooks/app/useGuidedSellingStatus");
var _BaseComponents = require("../StyledComponents/BaseComponents");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LightBackgroundGridRow = (0, _BaseComponents.LightBackground)(_r10SourceLibrary.GridRow);
var HeaderTop = function HeaderTop(_ref) {
  var actionComponent = _ref.actionComponent,
    isCloseButtonHidden = _ref.isCloseButtonHidden,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id;
  var _useGuidedSellingStat = (0, _useGuidedSellingStatus.useGuidedSellingStatus)(),
    closeGuidedSellingModal = _useGuidedSellingStat.closeGuidedSellingModal;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(LightBackgroundGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, actionComponent && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'left',
    verticalAlign: 'stretch'
  }, actionComponent)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'right',
    verticalAlign: 'stretch'
  }, !isCloseButtonHidden && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
    dataAttributes: {
      'data-id': 'modal-button-close'
    },
    srText: "Close",
    name: "close",
    appearance: "primary",
    onClick: closeGuidedSellingModal
  }))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    noMargin: true
  }));
};
var _default = HeaderTop;
exports.default = _default;